module.exports = __webpack_public_path__ + "media/more_review_app/assets/images/on_icon-453da3f3a9707f9599c972daaddd6358.svg";